import { useContext } from 'react'
import { SearchProfilesPageContext } from '../../../../providers/SearchProfilesPage'
import { AppDataContext } from '../../../../providers/AppData'
import {
  transformAutocompleteKeyword,
  transformAutocompletePractices,
  transformAutocompleteSpecialist
} from '../../../../utils/transformAutocomplete'
import AutocompleteResultsModal from '../AutocompleteResultsModal'
import { AutocompleteProps } from '../../common/types'
import { SearchTypes } from '../../../../providers/SearchProfilesPage/types'

const CustomAutocomplete = ({
  isSearchFieldFocused,
  setIsSearchFieldFocused,
  onChangeSearch,
  onSearchFieldBlur
}: AutocompleteProps) => {
  const {
    openProfilePage,
    state: { filters, practicesAutocomplete, specialistsAutocomplete, specialties, conditionsProcedures, specialty }
  } = useContext(SearchProfilesPageContext)
  const { language, tenantSettings } = useContext(AppDataContext)

  return (
    <AutocompleteResultsModal
      data={{
        specialties: specialties
          .map((spec) => transformAutocompleteKeyword(spec, tenantSettings?.locales[0] as string))
          .map((spec) => ({
            ...spec,
            onSelect: () => {
              setIsSearchFieldFocused(false)
            }
          })),
        conditionsProcedures: conditionsProcedures
          .map((conditionProcedure) =>
            transformAutocompleteKeyword(conditionProcedure, tenantSettings?.locales[0] as string)
          )
          .map((conditionProcedure) => ({
            ...conditionProcedure,
            onSelect: () => {
              setIsSearchFieldFocused(false)
            }
          })),
        profiles: (filters.searchType === SearchTypes.specialists ||
        filters.searchType === SearchTypes.healthAndSocialCare
          ? specialistsAutocomplete.map((specialist) =>
              transformAutocompleteSpecialist(specialist, tenantSettings?.locales[0] as string)
            )
          : practicesAutocomplete.map((practice) =>
              transformAutocompletePractices(practice, tenantSettings?.locales[0] as string)
            )
        ).map((profile) => ({
          ...profile,
          onSelect: () => {
            openProfilePage(profile.slug)
          }
        }))
      }}
      searchString={filters.searchString}
      onClose={onSearchFieldBlur}
      onChangeSearch={onChangeSearch}
      isOpen={isSearchFieldFocused}
      value={specialty.name[language]}
    />
  )
}

export default CustomAutocomplete
